module.exports = __webpack_public_path__ + "static/img/ckimg.be93855a.png";